###
# Модель зоны доставки
###
App.DeliveryZone = DS.Model.extend
  name                : DS.attr 'string'

  delivery_time            : DS.attr 'number'
  cooking_time             : DS.attr 'number'
  transportation_time      : DS.attr 'number'
  price                    : DS.attr 'number'
  free_delivery_count      : DS.attr 'number'
  free_delivery_price      : DS.attr 'number'
  minimal_order_price      : DS.attr 'number'

  rush_delivery_time       : DS.attr 'number'
  rush_cooking_time        : DS.attr 'number'
  rush_transportation_time : DS.attr 'number'
  rush_price               : DS.attr 'number'
  rush_free_delivery_price : DS.attr 'number'
  rush_minimal_order_price : DS.attr 'number'

  rush_delivery_time_expand_minutes : DS.attr 'number'

  courier_order_fee        : DS.attr 'number'
  service_charge  : DS.attr 'number'
  fixed_service_charge  : DS.attr 'number'

  priority      : DS.attr 'number'

  outsource_reject_from_price  : DS.attr 'number'
  outsource_free_delivery_price: DS.attr 'number'
  outsource_subsidy            : DS.attr 'number'
  outsource_provider           : DS.attr 'string'


  outsource_courier   : DS.attr 'boolean'

  takeaway: DS.attr 'boolean'
  dine_in:  DS.attr 'boolean'

  cooking_time_auto : DS.attr 'boolean'

  isTakeaway: Em.computed.alias('takeaway')
  isDineIn:   Em.computed.alias('dine_in')
  isDelivery: ( ->
    !@get('isTakeaway') and !@get('isDineIn')
  ).property('isTakeaway','isDineIn')

  timetables: DS.attr 'timetable'
  area : DS.attr 'polygon'

  # Внешние связи
  organization : DS.belongsTo 'organization', async: true
  restaurant   : DS.belongsTo 'restaurant',   async: true
